import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=8de50dac&scoped=true&"
import script from "./AppSidebar.vue?vue&type=script&lang=ts&"
export * from "./AppSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=8de50dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de50dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8de50dac')) {
      api.createRecord('8de50dac', component.options)
    } else {
      api.reload('8de50dac', component.options)
    }
    module.hot.accept("./AppSidebar.vue?vue&type=template&id=8de50dac&scoped=true&", function () {
      api.rerender('8de50dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppSidebar.vue"
export default component.exports